export class FileInfo {
    contentType: string
    extension: string

    constructor(contentType: string, extension: string) {
        this.contentType = contentType
        this.extension = extension
    }
}
